"use strict";

var curry = require("./curry.js");

var go = require("./go.js");

var identity = require("./identity.js");

var reduce = require("./reduce.js");

var mapL = require("../Lazy/mapL.js");

var takeUntilL = require("../Lazy/takeUntilL.js");

module.exports = curry(function some(f, iter) {
  return go(mapL(f, iter), takeUntilL(identity), reduce((a, b) => a || b), (a = false) => a, Boolean);
});